import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";

const XmlToJsonConverterContent = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 4 }}>
      {/* Intro */}
      <Typography variant="h4" fontWeight="bold" sx={{ fontSize: "1.75rem" }} gutterBottom>
        XML to JSON Converter – Effortlessly Convert XML Files to JSON Format
      </Typography>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Quickly Convert XML Data to JSON for Easy Access and Manipulation
      </Typography>
      <Typography variant="body1" paragraph>
        Looking for an efficient way to convert XML data into JSON? Our tool instantly transforms your XML files into JSON format, making it easier to work with structured data for analysis, integration, and more.
      </Typography>
      <Typography variant="body1" paragraph>
        Whether you're a developer, data analyst, or working with APIs, our XML to JSON converter simplifies your workflow by allowing you to easily convert and download data in just a few clicks.
      </Typography>

      {/* Features */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Why Use Our XML to JSON Converter?
      </Typography>
      <ul style={{ textAlign: "left", display: "inline-block" }}>
        <li>⚡ Convert XML to JSON instantly with just one click</li>
        <li>🔄 Handle complex XML data and nested structures with ease</li>
        <li>📊 Clean, structured JSON output ready for further processing</li>
        <li>📥 Download your JSON as a file or copy it to your clipboard</li>
      </ul>

      {/* How It Works */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        How to Use the XML to JSON Converter
      </Typography>
      <ol style={{ textAlign: "left", display: "inline-block" }}>
        <li>Upload your XML file or paste the XML data.</li>
        <li>Click “Convert to JSON” to process and generate the JSON output.</li>
        <li>Copy the JSON to your clipboard or download it as a file.</li>
      </ol>

      {/* SEO Paragraph */}
      <Typography variant="body1" paragraph mt={4}>
        Our <b>XML to JSON converter</b> is trusted by developers, data analysts, and businesses worldwide to convert XML data into structured JSON format. Whether you're working with APIs, databases, or project files, our tool ensures you have clean, usable JSON data in no time.
      </Typography>

      <Typography variant="body1" paragraph>
        Stop wasting time manually converting XML—let our <b>XML to JSON converter</b> handle the heavy lifting so you can focus on analysis, integration, and decision-making.
      </Typography>

      {/* FAQs */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        Frequently Asked Questions (FAQs)
      </Typography>
      <Typography variant="body1" fontWeight="bold">💡 What is an XML to JSON converter?</Typography>
      <Typography variant="body2" paragraph>
        An XML to JSON converter is a tool that takes XML data and converts it into JSON format, making it easier to analyze, manipulate, and integrate data into your applications or projects.
      </Typography>

      <Typography variant="body1" fontWeight="bold">🆓 Is the XML to JSON converter free?</Typography>
      <Typography variant="body2" paragraph>
        For Free plan users, 1 credit will be deducted for each conversion. All Paid plan users enjoy this tool for free 🎁 without any credit deduction.
      </Typography>

      <Typography variant="body1" fontWeight="bold">📈 Who should use an XML to JSON converter?</Typography>
      <Typography variant="body2" paragraph>
        Developers, data analysts, API users, or anyone working with XML data will benefit from this tool for quick and seamless conversion to JSON format.
      </Typography>

      {/* CTA */}
      <Box mt={4}>
        <Button variant="contained" color="primary" size="large" onClick={scrollToTop}>
          Convert XML to JSON Now
        </Button>
      </Box>
    </Container>
  );
};

export default XmlToJsonConverterContent;
